import { useTheme } from 'styled-components';
import {
  BodyLoader,
  ChartAssetCardsWrapper,
  Percentage,
  AssetName,
  Color,
} from './styles';

export const ChartAssetCardsLoader = () => {
  const { colors } = useTheme();

  return (
    <ChartAssetCardsWrapper>
      {[...Array(5)].map((item, i) => {
        return (
          <BodyLoader
            key={i}
            backgroundColor={colors.surface.interactiveDefault}
            foregroundColor={colors.surface.pressed}
          >
            <Percentage />
            <AssetName />
            <Color />
          </BodyLoader>
        );
      })}
    </ChartAssetCardsWrapper>
  );
};
